import { sendLeadToBitrix } from '@/shared/api';

export const landerApiSendLead = sendLeadToBitrix;
